<template>
  <div>
    <div class="rich-text-wrapper">
      <div
        v-html="content"
        id="rich-content"
        ref="contentRef"
      ></div>
    </div>
    <div class="file-wrap" v-if="fileList && fileList.length > 0">
      <p class="file-header">附件：</p>
      <el-row :gutter="20">
        <el-col :span="12" v-for="(item, index) in fileList" :key="index">
          <FileItem :data="item" :is-download="isDownload" :isShowSize="isShowSize" @preview="preview"/>
        </el-col>
      </el-row>
    </div>
    <PreviewMaterial
      v-model:visible="previewVisible"
      :fileData="activeFile"/>
  </div>
</template>

<script>
import FileItem from './file-item.vue';
import PreviewMaterial from '@/views/my-material/components/PreviewMaterial.vue';
// import photoSwiper from '@/components/photoSwiper/photoSwiper.vue';
const jQuery = require('jquery');

const MceHtmler = {
  name: 'mce-htmler',
  props: {
    authorInfo: { // 作者信息 name名字 avatar头像
      type: Object,
      default() {
        return {};
      }
    },
    // photoSwiperUseable: {
    //   type: Boolean,
    //   default: false
    // },
    content: {
      type: String,
      default: ''
    },
    fileList: { // 文件列表
      type: Array,
      default: () => []
    },
    isDownload: { // 是否允许下载 默认允许
        type: Boolean,
        default: true
    },
    isShowSize: { // 是否显示文件大小 默认显示
        type: Boolean,
        default: true
    }
  },
  data() {
    return {
      activeFile: {},
      previewVisible: false
    };
  },
  components: {
    FileItem,
    PreviewMaterial
    // photoSwiper
  },
  watch: {
    content(){
      if(this.content && this.content.length){
        this.clickImg();
      }
    }
  },
  mounted() {
    const self = this;
    let list = [];
    this.$nextTick(() => {
        this.clickImg();
    })
  },
  methods: {
    clickImg(){
        const self = this;
        let list = [];
        jQuery(this.$refs.contentRef).find('img').each(function(index, ele) {
          var $img = jQuery(ele);
          list.push({
            src: $img.attr('src'),
            thumbnail: $img.attr('src')
          });
          $img.bind('click', function() {
            self.$refs.photoswiper._open(list, index, self.authorInfo);
          });
        });
    },
    preview (item) {
      this.activeFile = item;
      this.previewVisible = true;
    }
  },
  install(Vue) {
    Vue.component('Mce-htmler', MceHtmler);
  }
};
export default MceHtmler;
</script>

<style lang="scss">
.rich-text-wrapper {
  color: #111a38;
  width: 100%;
  word-break: break-all;
  overflow: hidden;
  white-space: pre-wrap;
  font-size: 14px;
  // .top-bar {
  //   display: none;
  // }
  * {
    position: relative!important;
    max-width: 100%;
    overflow: hidden;
  }
  em {
    font-style: italic;
  }
  img {
    cursor: pointer;
    max-width: 100%;
    height: auto;
  }
  a {
    text-decoration: none;
  }
  iframe {
    width: 100%;
  }
  p {
    line-height: 1.6;
    margin: 0px;
  }
  table {
    word-wrap: break-word;
    word-break: break-all;
    max-width: 100%;
    border: none;
    border-color: #999;
  }
  .mce-object-iframe {
    width: 100%;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  ul,
  ol {
    list-style-position: inside;
  }
  ul{
    list-style: inherit;
    list-style-position: inside;
  }
  li {
    list-style: inside;
  }
  strong {
    font-weight: bold;
  }
}
.file-wrap {
  margin-top: 50px;
  .file-header {
    font-size: 16px;
    line-height: 16px;
    color: #333333;
  }
}
</style>
